// extracted by mini-css-extract-plugin
export var skeletonItem = "skeleton-item_NPPnDD0AdWjmgy38WDtd";